import {
   CAMEL_CASE_TYPES,
   WEEK_DAYS,
   PIPE_SYMBOL,
} from '../../../../utils/constants';

export function parsingData(rowData) {
   const uniqueUser = [...new Set(rowData?.map((record) => record.userId))];
   const userData = uniqueUser?.map((user) => ({ label: user, value: user }));
   userData?.unshift({
      label: CAMEL_CASE_TYPES.ALL,
      value: CAMEL_CASE_TYPES.ALL,
   });
   return userData;
}
export function searchFilter(searchValue, data) {
   return data.filter(
      ({ title }) =>
         title.includes(searchValue) ||
         title.includes(searchValue.toLowerCase()) ||
         title.includes(searchValue.toUpperCase())
   );
}
export function findEditRecord(data) {
   return data?.some((record) => record.isEdited);
}
export function filterRecord(id, data) {
   return data?.filter((record) => record.id !== id);
}
export function saveRequestParsing(data) {
   return data.reduce(
      (obj, item) => Object.assign(obj, { [item.id]: item }),
      {}
   );
}
export function updateSavedRecord(savedRecord, data) {
   return data.map((record) =>
      record.id === savedRecord.id ? savedRecord : record
   );
}
export function setFavouriteFirst(data) {
   data?.forEach((record, index) => {
      if (record.isFavourite) {
         data.splice(index, 1);
         data.unshift(record);
      }
   });
   return data;
}
export function findAllEditedRecord(data) {
   return data?.filter((record) => record.isEdited);
}
export function updateAllEditRecord(data) {
   // eslint-disable-next-line no-unused-vars
   return data?.map(({ isEdited, ...record }) => record);
}
export function scheduleDetailsParsing(
   scheduleDetails,
   data,
   selectedRowIndex,
   isEnableEdit
) {
   const scheduleStringRecord = [];
   scheduleDetails.forEach((scheduleRecord) => {
      const scheduleStringFormat = `${
         scheduleRecord.dayOfWeek !== WEEK_DAYS[1].value
            ? scheduleRecord.dayOfWeek.toString().substring(0, 3)
            : CAMEL_CASE_TYPES.ALL.substring(0, 3)
      }: ${scheduleRecord.hours
         .map((list) => list.toString().substring(0, 2))
         .toString()}`;
      scheduleStringRecord.push(scheduleStringFormat);
   });
   data[selectedRowIndex].scheduleData = scheduleStringRecord.join(PIPE_SYMBOL);
   data[selectedRowIndex].schedule = scheduleDetails;
   if (isEnableEdit) data[selectedRowIndex].isEdited = true;
   return [...data];
}

export function parsingScheduleDetails(storedCriteriaData) {
   storedCriteriaData.map((record, index) => {
      if (record?.schedule) {
         const updatedData = scheduleDetailsParsing(
            record.schedule,
            storedCriteriaData,
            index,
            false
         );
         record = updatedData[index];
      }
      return record;
   });
}
